import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";
import TrackingController from "../model/TrackingController";


export default class StartGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel
     * @param {TrackingController} trackingController
     */
    constructor(dispatcher, saveModel, gameModel, trackingController) {
        super(dispatcher);

        this._trackingController = trackingController;

        this.execute = function () {
            const saveGame = saveModel.getSaveGame();
            if (saveGame) {
                gameModel.restore(saveGame);

                const elapsedTime = gameModel.elapsedTime;
                this._trackingController.trackProgress(ProgressValue.RESUMED, elapsedTime);
            }
            if (gameModel.status == GameStatus.END) {
                this.gotoScreen(SkinKeys.END_SCREEN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN);
            }
        };
    };

}